import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Toaster, toast } from 'react-hot-toast';
import { useStateContext } from '../../contexts/ContextProvider';

import Axios from '../../Axios';
import '../../App.css';
import TermsModal from './TermsModal';
import rutValidator from '../../utils/validateRut';

import patternImg from "../../data/BioMap_Corfo.webp";

const initialState = { nombre: ' ', usuario: '', password: '', email: '', telefono: '', confirmPassword: '', rutEmpresa: '1111-1', razonSocial: '', tipoNegocio: 'almacen', rol: 'Administrador' };

export default function Login() {
  const { setCurrentColor, setCurrentMode } = useStateContext();
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState('');
  const [formData, setFormData] = useState(initialState);
  const [isSignup, setIsSignup] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);
  const [showOnboarding, setShowOnboarding] = useState(false);

  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);
  //const handleCheckboxChange = () => setIsCheckboxChecked(!isCheckboxChecked);
  const handleShowPassword = () => setShowPassword(!showPassword);

  useEffect(() => {
    const currentThemeColor = localStorage.getItem('colorMode');
    const currentThemeMode = localStorage.getItem('themeMode');
    if (currentThemeColor && currentThemeMode) {
      setCurrentColor(currentThemeColor);
      setCurrentMode(currentThemeMode);
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage('');

    if (!formData.usuario) return toast.error('Debe ingresar usuario');
    if (!formData.password) return toast.error('Debe ingresar la password');

    if (isCheckboxChecked=== false)
    {
     return toast.error('Debe Aceptar los Términos y condiciones de uso');
    }

    try {
      const response = await Axios.post('/usuario/loginuser', formData);
      const { data } = response;
      window.localStorage.setItem('profile', JSON.stringify(data.result));
      window.localStorage.setItem('token', JSON.stringify(data.token));
      window.localStorage.setItem('refreshToken', JSON.stringify(data.refreshToken));

      const necesitaOnboarding = data.result?.requiereOnboarding || false;
      if (necesitaOnboarding) {
        setShowOnboarding(true);
      } else {
        navigate('/Mi Biopanel');
      }
    } catch (error) {
      console.error('Error ' + error + ' ' + error.message);
      toast.error('Usuario y/o Password Incorrectos');
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  
  const handleCheckboxChange = () => {
    setIsCheckboxChecked(!isCheckboxChecked);
  };

  const switchMode = () => {
    setErrorMessage('');
    setIsSignup((prevIsSignup) => !prevIsSignup);
    setShowPassword(false);
    setIsCheckboxChecked(false);
  };

 const handleOnboardingOpen = () => {
    navigate("/onboarding");
  }

  return (
    <section className="m-8 flex flex-col lg:flex-row gap-4">
      <div className="w-full lg:w-3/5 mt-10">
        <div className="text-center">
          <img src="/images/Logo_biomap_SVG_Jul_2025.svg" alt="Logo" className="mx-auto mb-4 w-48" />
          <h2 className="text-3xl text-green-700 font-bold mb-4">Bienvenido</h2>
          <p className="text-lg text-gray-700">Ingrese su usuario y password para comenzar.</p>
        </div>
        <form className="mt-8 mb-2 mx-auto w-80 max-w-screen-lg lg:w-1/2" autoComplete="off" onSubmit={handleSubmit}>
          <div className="mb-6 flex flex-col gap-6">
            <label className="text-sm font-medium text-gray-700" htmlFor="email">
              Usuario
            </label>
            <input
              name="usuario"
              onChange={handleChange}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-900"
            />

            <label className="text-sm font-medium text-gray-700" htmlFor="password">
              Password
            </label>
            <input
              name="password"
              type="password"
              onChange={handleChange}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-900"
            />
          </div>

          <div className="flex items-center gap-2 mb-4">
            <input
              id="terms"
              type="checkbox"
              checked={isCheckboxChecked}
              onChange={handleCheckboxChange}
              className="w-4 h-4 text-gray-900 border-gray-300 rounded focus:ring-0"
            />
            <label htmlFor="terms" className="text-sm text-gray-600">
              Estoy de acuerdo con los <a href="#" className="text-black underline">Términos y Condiciones</a>
            </label>
          </div>

          <button type="submit" className="w-full py-2 bg-green-950 text-white rounded-lg hover:bg-gray-600">
            Ingresar
          </button>

          <div className="flex flex-col items-center gap-2 mt-6 text-sm text-gray-900">
            <a href="#" className="underline">Olvido su Password</a>
            <button
              type="button"
              onClick={handleOnboardingOpen}
              className="underline text-green-800 hover:text-green-900"
            >
              ¿No tienes una cuenta? Regístrate.
            </button>
          </div>
        </form>
      </div>

      <div className="w-full lg:w-2/5 flex items-end justify-center mt-4 lg:mt-0">
        <img src={patternImg} alt="Background" className="object-cover rounded-3xl max-w-xs lg:max-w-full" />
      </div>
        <Toaster position="top-right" toastOptions={{ style: { zIndex: 9999 } }} />
    </section>
  );
}
